// extracted by mini-css-extract-plugin
export default {"returnButton":"returnButton_returnButton__VXPhB","narrow":"returnButton_narrow__ZN0SI","normal":"returnButton_normal__jQSKD"};